<template>
    <fragment>
        <li class="menu-section" :class="{ 'menu-item-open': hasActiveChildren }">
            <h4 class="menu-text">Quản lý sản xuất</h4>
        </li>

        <!-- Quản lý đơn vị SX -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_LY_DON_VI_SX)"
            icon="fas fa-indent"
            text="Quản lý đơn vị SX"
            :items="productionUnitItems"
        />

        <!-- Quản lý dạy học -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_LY_DAY_HOC)"
            icon="fas fa-solid fa-graduation-cap"
            text="Quản lý dạy học"
            :items="teachingManagementItems"
        />

        <!-- Quản lý admin -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_LY_ADMIN)"
            icon="fas fa-solid fas fa-bookmark"
            text="Quản lý admin"
            :items="adminManagementItems"
        />

        <!-- Điều phối lớp học -->
        <MenuSubmenu
            v-if="hasPermission(permission.DIEU_PHOI_LOP_HOC)"
            icon="fas fa-users"
            text="Điều phối lớp học"
            :items="classCoordinationItems"
        />

        <!-- Coi thi - Chấm thi -->
        <MenuSubmenu
            v-if="hasPermission(permission.COI_THI_CHAM_THI)"
            icon="fas fa-marker"
            text="Coi thi - Chấm thi"
            :items="examManagementItems"
        />

        <!-- Quản trị chất lượng -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_TRI_CHAT_LUONG)"
            icon="fas fa-marker"
            text="Quản trị chất lượng"
            :items="qualityManagementItems"
        />

        <!-- R&D Sản phẩm -->
        <MenuLink
            v-if="hasPermission(permission.RD_SAN_PHAM)"
            :to="{ name: 'rd-product' }"
            icon="far fa-gem"
            text="R&D Sản phẩm"
        />
    </fragment>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuLink from './MenuLink'
import MenuSubmenu from './MenuSubmenu'

export default {
    name: 'ProductionManagementMenu',

    components: {
        MenuLink,
        MenuSubmenu
    },

    computed: {
        ...mapGetters(['currentUser']),

        hasActiveChildren() {
            const activeRoutes = ['/centers', '/branches', '/courses', '/area']
            return activeRoutes.some(route => this.$route.path.includes(route))
        },

        productionUnitItems() {
            return [
                {
                    name: 'center-educenter',
                    text: 'Trung tâm',
                    permission: null // Always visible if parent has permission
                },
              {
                text: 'Quản lý giảng viên',
                permission: this.permission.QUAN_LY_GIANG_VIEN, // Always visible if parent has permission
                icon: 'menu-bullet-dot',
                children: this.lecturerManagementItems
              },
                {
                    name: 'course-level-list',
                    text: 'Trình độ',
                    permission: null
                },
                {
                    name: 'branch-index',
                    text: 'Chi nhánh',
                    permission: null
                },
                {
                    name: 'manage-school-schedules',
                    text: 'Lịch học',
                    permission: this.permission.LICH_HOC
                },
                {
                    name: 'ProductionManagement',
                    text: 'Nguồn lực mở lớp',
                    permission: this.permission.NGUON_LUC_MO_LOP
                },
                {
                    name: 'ManageGroupTeacher',
                    text: 'Quản lý nhóm giảng viên',
                    permission: null
                },

            ]
        },
       lecturerManagementItems(){
         return [
           {
             name: 'teaching-report',
             text: 'Báo cáo dạy học',
             permission: this.permission.BAO_CAO_DAY_HOC
           },
           {
             name: 'error-list',
             text: 'Danh sách lỗi',
             permission: this.permission.DANH_SACH_LOI
           },
           {
             name: 'teacher-list',
             text: 'Giảng viên',
             permission: this.permission.GIANG_VIEN
           },
           {
             name: 'ManageGroupTeacher',
             text: 'Nhóm giảng viên',
             permission: this.permission.NHOM_GIANG_VIEN
           },
           {
             name: 'manage-candidate-teacher',
             text: 'Ứng viên giảng viên',
             permission: this.permission.UNG_VIEN_GIANG_VIEN
           },
         ]
       },
      teachingManagementItems() {
            return [
                {
                    name: 'event-list',
                    text: 'Sự kiện',
                    permission: this.permission.SU_KIEN
                },
                {
                    name: 'workshop-club-list',
                    text: 'Workshop & Club',
                    permission: this.permission.WORKSHOP_CLUB
                },
                {
                    name: 'off-lesson-list',
                    text: 'Duyệt buổi nghỉ học',
                    permission: this.permission.DUYET_NGHI_BUOI_HOC
                },
                {
                    name: 'schedule-course-list',
                    text: 'Quản lý lộ trình',
                    permission: this.permission.QUAN_LY_LO_TRINH
                },
                {
                    name: 'exam-index',
                    text: 'Buổi kiểm tra',
                    permission: this.permission.BUOI_KIEM_TRA
                },
                {
                    name: 'manage-error',
                    text: 'Sửa lỗi dạy học',
                    permission: this.permission.SUA_LOI_DAY_HOC
                },
                {
                    name: 'class-timesheets',
                    text: 'Quản lý công demo',
                    permission: this.permission.SUA_LOI_DAY_HOC
                },
                {
                    name: 'export-teacher-timesheets',
                    text: 'Export Công giáo viên',
                    permission: this.permission.SUA_LOI_DAY_HOC
                },
                {
                    name: 'report-classroom-stats',
                    text: 'Report Công giáo viên',
                    permission: this.permission.SUA_LOI_DAY_HOC
                },
                {
                    name: 'tournamentList',
                    text: 'Đấu trường',
                    permission: this.permission.GIAI_DAU
                }
            ]
        },

        adminManagementItems() {
            return [
              {
                text: 'Test đầu vào',
                icon: 'menu-bullet-dot',
                permission: this.permission.TEST_DAU_VAO,
                children: this.testInputItems
              },
              {
                text: 'Gia sư',
                icon: 'menu-bullet-dot',
                permission: this.permission.GIA_SU,
                children: this.tutorItems
              }
            ]
        },
      tutorItems(){
          return [
            {
                  name: 'report-for-tutor',
                  text: 'Báo cáo',
                  permission: this.permission.REPORT_CA_GIA_SU
            },
            {
              name:'human-management',
              text:'Nhân sự gia sư',
              permission: this.permission.QUAN_LY_NHAN_SU_GIA_SU
            },
            {
              name:'task-management',
              text:'Quản lý tác vụ',
              permission: this.permission.QUAN_LY_TAC_VU_GIA_SU
            },
            {
              name:'tutor-personal-task',
              text:'Tác vụ cá nhân',
              permission: this.permission.TAC_VU_CA_NHAN_GIA_SU
            },
            // {
            //   name:'task-management',
            //   text:'Tác vụ cá nhân',
            //   permission: this.permission.NHAN_SU_ADMIN
            // }
          ]
      },
       testInputItems(){
         return [
           {
             name: 'tester-list',
             text: 'Nhân sự admin',
             permission: this.permission.NHAN_SU_ADMIN
           },
           {
             name: 'task-manager',
             text: 'Quản lý tác vụ',
             permission: this.permission.QUAN_LY_TAC_VU
           },
           {
             name: 'entrance-test-schedule',
             text: 'Lịch trực test đầu vào',
             permission: this.permission.LICH_TRUC_TEST_DAU_VAO
           },
           {
             name: 'report-test',
             text: 'Report ca test',
             permission: this.permission.REPORT_CA_TEST
           },
           {
             name: 'task-manager-personal',
             text: 'Tác vụ cá nhân',
             permission: this.permission.TAC_VU_ADMIN_CA_NHAN
           }
         ]
       },
        classCoordinationItems() {
            return [
                {
                    name: 'TaskManagementList',
                    text: 'Quản lý tác vụ',
                    permission: this.permission.QUAN_LY_TAC_VU_DIEU_PHOI_LOP_HOC
                },
                {
                    name: 'TaskArrangePersonal',
                    text: 'Tác vụ cá nhân',
                    permission: this.permission.TAC_VU_XEP_LOP_CA_NHAN
                }
            ]
        },

        examManagementItems() {
            return [
                {
                    name: 'ManageExamScheduleList',
                    text: 'Quản lý lịch thi',
                    permission: this.permission.QUAN_LY_LICH_THI
                },
                {
                    name: 'ExamShifts',
                    text: 'Quản lý ca thi',
                    permission: this.permission.QUAN_LY_CA_THI
                },
                {
                    name: 'ManageRetestList',
                    text: 'Đăng ký thi lại',
                    permission: this.permission.DANG_KY_THI_LAI
                },
                {
                    name: 'marking-exam-index',
                    text: 'Quản lý đề thi',
                    permission: this.permission.QUAN_LY_DE_THI
                },
                {
                    name: 'admin-index',
                    text: 'Quản lý admin',
                    permission: this.permission.QUAN_LY_DE_THI
                },
                {
                    name: 'ManageTaskList',
                    text: 'Danh sách tác vụ',
                    permission: this.permission.DANH_SACH_TAC_VU
                },
                {
                    name: 'PersonalTaskList',
                    text: 'Danh sách tác vụ cá nhân',
                    permission: this.permission.DANH_SACH_TAC_VU_CA_NHAN
                },
                {
                    name: 'InvigilationReport',
                    text: 'Báo cáo chỉ số coi thi',
                    permission: this.permission.COI_THI_CHAM_THI
                }
            ]
        },

        qualityManagementItems() {
            return [
            {
                name : 'report-error-index',
                text : 'Bảng báo lỗi',
                permission : this.permission.BANG_BAO_LOI
            },
            {
                text: 'Thanh tra chấm BTVN',
                icon: 'menu-bullet-dot',
                permission: this.permission.THANH_TRA_CHAM_BTVN,
                children: this.thanhTraChamBTVNItems
            },

            ]
        },
        thanhTraChamBTVNItems() {
            return [
            {
                name : 'inspection-homework-management',
                text : 'Quản lý tác vụ',
                permission : this.permission.QUAN_LY_TAC_VU_THANH_TRA_CHAM_BTVN
            },
            {
                name : 'inspection-homework-personal',
                text : 'Tác vụ cá nhân',
                permission : this.permission.TAC_VU_CA_NHAN_THANH_TRA_CHAM_BTVN
            }

            ]
      }
    },

    methods: {
        hasPermission(permission) {
            return this.currentUser?.user?.permission?.includes(permission)
        }
    }
}
</script>

